import { useAEMComponentData } from "@AEM/AEMContentLoader"
import { AEMComponentMapper, AEMPageType } from "@AEM/models/AEMPage.model"
import { AEMSvg } from "@components/AEMSvg"
import { useAEMIcons } from "@hooks/useAEMIcons"
import { Box, Flex, Text } from "@mantine/core"
import { FC } from "react"
import styles from "./MaintenanceBanner.module.css"

interface MaintenanceBannerProps {
	show?: boolean
}

export const MaintenanceBanner: FC<MaintenanceBannerProps> = ({
	show = false
}) => {
	if (!show) {
		return null
	}
	const { componentData } = useAEMComponentData(
		AEMPageType.DICTIONARY,
		AEMComponentMapper.APP_DICTIONARY
	)
	const { icons } = useAEMIcons()

	return (
		<Flex
			align="center"
			justify="center"
			gap="md"
			className={styles.maintenanceBanner}
		>
			<AEMSvg svgData={icons["qa-mode.svg"]} w={24} h={24} />
			<Box>
				<Text fw={600} fz={14}>
					{componentData?.qaModeAlertTitle}
				</Text>
				<Text fz={12} className={styles.subtitleText}>
					{componentData?.qaModeAlertDescription}
				</Text>
			</Box>
		</Flex>
	)
}
